<div class="profile-status-container" ngbDropdown placement="left"
  [ngbTooltip]="(agentQueueTypes?.length > 0) ? '' : emptyQueueTooltip">
  <button ngbDropdownToggle class="btn availability-menu" href="javascript: void(0);" data-toggle="dropdown"
    aria-haspopup="true" aria-expanded="false"
    [disabled]="unlockButton === false || userSessionStatus?.name === 'undefined'" style="border-left: 0;">
    <div class="profile-status">
      <i class="fa fa-circle profile-status-ico" [ngClass]="userSessionStatus?.name" aria-hidden="true"></i>
      <span class="profile-status-text">{{'admin.trobbitlive.module.agents.agentAvailability.' +
        userSessionStatus?.name | translate}}</span>
    </div>
    <i class="fa fa-chevron-down"></i>
  </button>


  <ng-container *ngIf="unlockButton === true">
    <div ngbDropdownMenu class="availability-dropdown">
      <ng-container *ngFor="let status of availabilityStatus">
        <button *ngIf="status.id !== 5" ngbDropdownItem (click)="changeSessionStatus(status)">
          <div class="profile-status">
            <i class="fa fa-circle profile-status-ico" [ngClass]="status.name" aria-hidden="true"></i>
            <span class="profile-status-text">{{'admin.trobbitlive.module.agents.agentAvailability.' + status.name |
              translate}}</span>
          </div>
        </button>
      </ng-container>
    </div>
  </ng-container>

</div>
